$(function () {
  renderMarkdown($('#footer-text'), $.polyglot.t('footer_text', $.interpolations));
  renderMarkdown($('#footer_links'), $.polyglot.t('footer_links', $.interpolations));
  renderMarkdown($('#ecommerce-order-confirmation-explanation'), $.polyglot.t('ecommerce_order_confirmation_explanation', $.interpolations));
  renderMarkdown($('#create-account-benefits'), $.polyglot.t('create_account_benefits', $.interpolations));
  renderMarkdown($('#ecommerce-top-bar'), $.polyglot.t('ecommerce_top_bar', $.interpolations));
});
 $(function() {

  $('.mobile-sidebar-toggler').on('click', function(){
    $('body.ecommerce').toggleClass('sidebar-open');
  });

  $('.mobile-search-filters-toggle').on('click', function(){
    $('body.ecommerce').toggleClass('search-filters-open');
  });

    $(".pdp-add-to-cart-btn").on('click', function() {
        $(window).resize();
    });

    $(".search-items .pdp-add-to-cart-btn").on('click', function() {
        searchAddCart();
    });

  $(document).on("click", ".payment-promo-link", function(e) {
    e.preventDefault();
    $(".promo-payment-drop").toggle();
    $(".payment-promo-link").hide();
  })

  $('.pdp-section-header').on('click', function(){
      $(this).children('.expand-icon').toggleClass('fa-minus fa-plus');
  });

  $('*[data-toggle="collapse"]').on('click', function(){
    $(this).parent('.collapse-section').children('.expand-icon').toggleClass('fa-minus fa-plus');
  });
  $('*[data-toggle="collapse"]').on('click', function(){
    $(this, '.expand-icon').toggleClass('fa-minus fa-plus');
  });
  $('.footer-links .expand-section').on('click', function(){
    $(this).children('.expand-icon').toggleClass('fa-minus fa-plus');
      $(this).removeClass('fa-minus');
      $(this).removeClass('fa-plus');
  });

    $('.sidebar-expand-section').on('click', function(){
        if($(this).find('i').hasClass('fa-plus')) {
            $(this).find('i').removeClass('fa-plus');
            $(this).find('i').addClass('fa-minus');
        }
        else {
            $(this).find('i').removeClass('fa-minus');
            $(this).find('i').addClass('fa-plus');
        }
    });


    $('.checkbox-same-shipping').on('click', function(){
        var payReviewHeight = $('#billing-address-form').height();
        var payReviewState;
        if(payReviewState != "yes") {
            $('footer').css('margin-top', payReviewHeight + 'px');
            payReviewState = "yes";
        }
        else {
            $('footer').css('margin-top', '0px');
            payReviewState = "no";
        }
    });

  $('.mobile-sidebar-toggler').on('click', function(){
    $(this).children('.fal').toggleClass('fa-bars fa-times');
  });

  $('.search-cards').on('click', function(){
    $('.search-results').addClass('search-cards');
    $('.search-cards-icon').addClass('text-primary');
    $('.search-results').removeClass('search-list');
    $('.search-list-icon').removeClass('text-primary');
  });

  $('.search-list').on('click', function(){
    $('.search-results').addClass('search-list');
    $('.search-list-icon').addClass('text-primary');
    $('.search-results').removeClass('search-cards');
    $('.search-cards-icon').removeClass('text-primary');
  });

  $('.menu-nav-md .nav').find('> li').on('click', function () {
      $('.nav > li').not(this).find('ul').removeClass('nav-sublist-open');
      $('.nav > li').not(this).find('.nav-list-item-link-icon').removeClass('fa-angle-up');
      $('.nav > li').not(this).find('.nav-list-item-link-icon').addClass('fa-angle-down');
      $('.nav > li').not(this).find('.nav-list-item-link').removeClass('text-primary');
      $(this).find('ul').stop(true, true).toggleClass('nav-sublist-open');
      $(this).find('.nav-list-item-link-icon').stop(true, true).toggleClass('fa-angle-down fa-angle-up');
      $(this).find('.nav-list-item-link').stop(true, true).toggleClass('text-primary');
      return false;
  });

    $('.menu-nav-md .nav .nav-list-item-link').on('click', function() {
        var prodfeatArr = [];
       $(this).parent('li.nav-list-item').find('img.img-details').each(function(obj) {
           var prodfeatName = $(this).data('pname');
           var prodfeatSku = $(this).data('psku');
           var prodfeatCat = $(this).data('pcat');
           var prodfeatI = $(this).data('pipos');
           var prodfeatObj = {
               id: prodfeatSku,
               name: prodfeatName,
               category: prodfeatCat,
               brand: '',
               list: 'Navigation',
               position: prodfeatI
           }
           prodfeatArr.push(prodfeatObj);
       });
       if(prodfeatArr.length > 0) {
           gtmRecTag(prodfeatArr);
       }
    });

  $('ul.nav-sublist li a').on('click', function() {
    var navurl = $(this).attr('href');
    document.location.href = navurl;
  });

  $(window.document).on('click', function(){
    if( $(".nav-sublist").hasClass("nav-sublist-open") ){
      $(".nav-sublist").removeClass("nav-sublist-open");
      $(".nav-list-item-link").removeClass("text-primary");
      $(".nav-list-item-link-icon").removeClass("fa-angle-up");
      $(".nav-list-item-link-icon").addClass("fa-angle-down");
    };
  });

  $(".pdp-add-to-cart-btn").on('click', function () {
    disableButton();
  });

  function disableButton(){
    if ($("#add-to-cart-modal").is(":visible") && sessionStorage.clickcount == 1) {
      $('.pdp-add-to-cart-btn').removeClass('disable-pointer');
      $('.pdp-add-to-cart-btn').prop('disabled', false);
      sessionStorage.clickcount = 0;
    } else {
      $('.pdp-add-to-cart-btn').addClass('disable-pointer');
      $('.pdp-add-to-cart-btn').prop('disabled', true);
      sessionStorage.clickcount = 1;
    }
}


  if (typeof lightSlider === 'function') {
      $("#lsAtcRecommended").lightSlider({
          item: 4,
          slideMove: 4,
          slideMargin: 5,
          nextHtml: "<i class='fas fa-arrow-circle-right text-dark fa-2x'></i>",
          prevHtml: "<i class='fas fa-arrow-circle-left text-dark fa-2x'></i>",
          responsive: [
              {
                  breakpoint: 768,
                  settings: {
                      item: 2,
                      slideMove: 2,
                      slideMargin: 6,
                  }
              }
          ]
      });

      $("#lsPdpGallery").lightSlider({
          item: 4,
          controls: false,
          responsive: [
              {
                  breakpoint: 1600,
                  settings: {
                      item: 5,
                      slideMove: 5,
                      slideMargin: 6,
                  }
              },
              {
                  breakpoint: 1200,
                  settings: {
                      item: 4,
                      slideMove: 4,
                      slideMargin: 6,
                  }
              },
              {
                  breakpoint: 992,
                  settings: {
                      item: 4,
                      slideMove: 4,
                      slideMargin: 6,
                  }
              },
              {
                  breakpoint: 768,
                  settings: {
                      item: 4,
                      slideMove: 4,
                      slideMargin: 6,
                  }
              },
              {
                  breakpoint: 500,
                  settings: {
                      item: 3,
                      slideMove: 3,
                      slideMargin: 6,
                  }
              }
          ]
      });

  }

    $('.bestSellersSlider').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 3,
        dots: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 780,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            }
        ]
    });

   $(window).on("load",function () {

    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('.aura-header').height();
    var overviewHeight = $('.product-overview').height();
    var stickyHeight = (navbarHeight + overviewHeight);

    $(window).on('scroll', function (event) {
      didScroll = true;
    });

    setInterval(function () {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);

    function hasScrolled() {
      var st = $(this).scrollTop();

      // Make sure they scroll more than delta
      if (Math.abs(lastScrollTop - st) <= delta)
        return;

      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      if (st > lastScrollTop && st > stickyHeight) {
        // Scroll Down
        $('body.ecommerce #product-sticky-header').addClass('d-md-block').addClass('sticky');
      } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
            var hashLoc = window.location.hash;
            if(hashLoc == '#product-info-highlights' ||
                hashLoc == '#product-included' ||
                hashLoc == '#product-overview' ||
                hashLoc == '#product-specs' ||
                hashLoc == '#product-info-highlights' ||
                hashLoc == '#pdp-section-shipping' ||
                hashLoc == '#pdp-section-returns') {
                if (st < lastScrollTop && st < stickyHeight) {
                    $('body.ecommerce #product-sticky-header').removeClass('d-md-block').removeClass('sticky');
                }
            }
            else {
                $('body.ecommerce #product-sticky-header').removeClass('d-md-block').removeClass('sticky');
            }
        }
      }

      lastScrollTop = st;
    }
  });

  $('#lsPdpGallery').on('img', 'click', function () {
    $('#ex1').addClass('d-inline-block');
    $('#ex1').removeClass('d-none');
    $('#gallery-video').removeClass('d-flex');
    $('#gallery-video').addClass('d-none');
    $('.largeImage').attr('src', $(this).attr('src').replace('thumb', 'large'));
    $('.zoomImg').attr('src', $(this).attr('src').replace('thumb', 'large'));
    $('#gallery-video-embed').removeAttr('src');
  });

  $('.carousel-item-outer').on('click', function(){
    $('.carousel-item-outer').removeClass('selected');
    $(this).addClass('selected');
  });

  $(".video-embed").on('click', function(){
    var video_id = $(this).data('vid');
    $('#ex1').addClass('d-none');
    $('#ex1').removeClass('d-inline-block');
    $('#gallery-video').removeClass('d-none');
    $('#gallery-video').addClass('d-flex');
    $('#gallery-video-embed').attr('src', 'https://www.youtube.com/embed/' + video_id );
  });

});

var pathname = window.location.pathname;

var mobSearch = function() {
    window.location.href = "/products_search";
}

var searchDirect = function() {
    var searchTerm = $('#search').val();
    var searchLink = '/products_search/?se=' + searchTerm;
    window.location.href = searchLink;
}

$('.searchHand').on('submit', function(e) {
    e.preventDefault();
    var accessTerm = $('.search-key-com').val();
    var searchLinkM = '/products_search/?se=' + accessTerm;
    //$(this).append('Mobile Search Term: ' + accessTerm + '<br>');
    window.location.href = searchLinkM;

});

if(pathname != '/products_search' && pathname != '/products_search/') {
  $('.desktop-only #btn-search').on('click', function() {
    searchDirect();
  });
  $('.desktop-only #search').on('keydown', function (e) {
      var key = e.which;
      if(key == 13 || key == 229) {
          searchDirect();
      }
  });
}

$('.breadcrumb-back a').on('click', function(e) {
    e.preventDefault();
    var url = document.referrer;
    var domainCatch = document.referrer.split('/')[2];
    if (domainCatch.indexOf("fujifilm") >= 0) {
        window.history.back();
    }
    else {
        window.location = '/';
    }
});

$('body.fps-checkout-page .brand-logo-anchor').on( 'click', function(e) {
    e.preventDefault();
    var winAnchorOut = window.open('https://www.fujifilm.com/', '_blank');
    winAnchorOut.focus();
});

$('.pdp-dealer-btn').on('click', function(e) {
  e.preventDefault();
  var url = 'https://fujifilm-x.com/en-us/shop/';
  window.open(url, '_blank');
});

$('input.vradisabled').attr('disabled', 'disabled');

$('body.ecommerce-home-page .pdp-section-header h3').text('Best Sellers');

// Fixed payment summary on scroll
var page_window_width_mob = $(window).width();

var wrapheight =  $('.page-wrap').height();

if(wrapheight > 750 && page_window_width_mob > 770) {

  $(function($) {
    var pWidth =  $('#ecommerce_payment_summary').width() + 'px';
    var fHeight =  $('.aura-footer-inner').height();
    var scrollBottom = $(window).scrollTop() + $(window).height();
    $(window).on('scroll', function fix_element() {
        var page_origin = window.location.origin;
        var windowScrollMargin;
        if((page_origin.indexOf('olympus') >= 0) || (page_origin.indexOf('omprotect') >= 0) || (page_origin.indexOf('omsystem') >= 0)) {
          var headerHeight = $('.aura-header').height();
          var heroBannerHeight = $('.aura-content-wrapper').prev().height();
          var contentHeaderHeight =  $('.aura-content').prev().height();
          var scrollMargin = headerHeight + heroBannerHeight + contentHeaderHeight;
          windowScrollMargin = scrollMargin;
        } else {
          windowScrollMargin = 300;
        }
        if($(window).scrollTop() > windowScrollMargin) {
          $('#ecommerce_payment_summary').css('position', 'fixed');
          $('#ecommerce_payment_summary').css('width', pWidth);
        }
        else {
          $('#ecommerce_payment_summary').css('position', 'relative');
        }
      return fix_element;
    }());
  });

  $(window).on('scroll', function() {
    topOfFooter = $('footer').position().top;
    var sidebarheight =  $('#ecommerce_payment_summary').height() + 45;
    $('#ecommerce_payment_summary').css('top', '10px');
    scrollDistanceFromTopOfDoc = $(document).scrollTop() + sidebarheight;
    scrollDistanceFromTopOfFooter = scrollDistanceFromTopOfDoc - topOfFooter;
    if (scrollDistanceFromTopOfDoc > topOfFooter) {
      $('#ecommerce_payment_summary').css('margin-top',  0 - scrollDistanceFromTopOfFooter);
    } else  {
      $('#ecommerce_payment_summary').css('margin-top', 0);
    }
  });


  var payHeight = $('.aura-container .checkout-summary-full').height();
  var payFullHeight = payHeight + 'px';
  //$('.aura-container .checkout-summary-full').css('height', payFullHeight);

}

 $(function() {
    if(page_window_width_mob < 770) {
        $('.nav-dropdown-user').on('click', function() {
            $('body').append('<div class="modal-backdrop fade show" style="z-index:140;opacity:.8;"></div>')
            $('.dropdown-user').addClass('fade show');
        });

        $('.mobile-search-filters-toggle').on('click', function() {
            //$('body').append('<div class="modal-backdrop fade show" style="z-index:140;opacity:.8;"></div>');
        });

        $('.main-nav-toggler').on('click', function() {
            $('body').append('<div class="modal-backdrop fade show" style="z-index:140;opacity:.8;"></div>');
        });

        $('.navbar-toggler').on('click', function() {
            $('body').append('<div class="modal-backdrop fade show" style="z-index:140;opacity:.8;"></div>');
        });

        // If mobile collapse all PDP info sections on page load
        $('.pdp-section-expand').removeClass('show');
        $('.pdp-section-expand').closest('section').find('.pdp-section-header').append('<i class="expand-icon fas ml-auto fa-plus" aria-hidden="true"></i>');

    }
});


$('.user-menu button.close').on('click', function() {
    $('.user-menu').removeClass('dropdown-menu-open');
    $('body').find('.modal-backdrop').remove();
    $('body').trigger('click');
});

$('.mobile-search-filters-close').on('click', function() {
    $('body').removeClass('search-filters-open');
    $('body').find('.modal-backdrop').remove();
});

$('.mobile-main-nav-close').on('click', function() {
    $('body').removeClass('sidebar-open');
    $('body').find('.modal-backdrop').remove();
});

// $('body').click(function(){
//     if($('body').hasClass('ecommerce-search-page')) {
//         //$('body').find('.modal-backdrop').remove();
//     }
//     else {
//         $('body').find('.modal-backdrop').remove();
//     }
// });

$(document).on('mouseup', function(e)
{
    var container = $(".modal-dialog");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
        $('body').find('.modal-backdrop').remove();
    }
});

// The function actually applying the offset
function offsetAnchor() {
    if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 200);
    }
}

// Captures click events of all <a> elements with href starting with #
$('.pdp-sticky-header-nav').on('click', 'a[href^="#"]', function(event) {
    // Click events are captured before hashchanges. Timeout
    // causes offsetAnchor to be called after the page jump.
    window.setTimeout(function() {
        offsetAnchor();
    }, 0);
});

var pathglobal_name = window.location.pathname;
if(pathglobal_name != '/products_cart' && pathglobal_name != '/products_payment') {
    // If user is not on cart or checkout page set session referrer var
    sessionStorage.setItem("cartReferrer", pathglobal_name);
}

// Continue Shopping cart / checkout link
var continueLink = function() {
    var pathname = window.location.pathname;
    if(pathname == '/products_cart' || pathname == '/products_payment') {
        var catchCartReferrer = sessionStorage.getItem('cartReferrer');
        if(catchCartReferrer.length > 0) {
            window.location.href = catchCartReferrer;
        }
        else {
            window.location.href = '/products_home';
        }
    }
}

$('.cart-continue-link a').on('click', function() {
    continueLink();
});

$(".sliding-link").on('click', function(e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({scrollTop: $(aid).offset().top},'slow');
});

 $(function() {
    var catchPromo = sessionStorage.getItem('promo_primary');
    var yousavedAmount;
    yousavedAmount = $('.you-saved-amount').text();
    if(yousavedAmount != '$0.00') {
      if(catchPromo != '' && catchPromo != null) {
        $('.promo-status').append('<p>Promo Applied: ' + catchPromo + '</p>');
        $('.payment-promo-drop, .payment-promo-link').hide();
      }
    }
})

$.fn.isOnScreen = function(){
    var win = $(window);
    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();
    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};

$('.pdp-attribute-1 .custom-radio input[type=radio]').on('click', function() {
    if($(this).data('attr-active') == 'true') {
        $(this).prop('checked', false);
        $(this).data('attr-active', 'false');
        $(this).parents('.pdp-attribute-1').find('.bundle-title-2 span').html('');
    } else {
        $(this).data('attr-active', 'true');
    }
});

$('.logout-link').on('click', function(e) {
  e.preventDefault();
  $('#logout_form').submit();
});

function formatShipDate(date) {
  var shipRep = date.replaceAll('-', '/');
  var shipGroundObj = shipRep.split("/");
  var shipGroundText = shipGroundObj[1] + '/' + shipGroundObj[2] + '/' + shipGroundObj[0];
  var shipGroundDate = new Date(shipGroundText) + '';
  var shipGround = shipGroundDate.split('00:00:00');
  var shipGrFull = shipGround[0];
  var shipGroundFinal = shipGrFull.substring(0, shipGrFull.length - 5);
  var shipGroundSplit = shipGrFull.split(' ');
  return (shipGroundSplit[0] + ', ' + shipGroundSplit[1] + ' ' + shipGroundSplit[2]);
}

function addDaysDate(fDate, numDays) {
  var date = fDate;
  var year = date.getFullYear();
  var month = ("0" + (date.getMonth() + 1)).slice(-2);
  var day = ("0" + (date.getDate() + numDays)).slice(-2);
  var daysh = new Date();
  var dayshort = daysh.setDate(date.getDate() + numDays);
  var dayshort = daysh.toLocaleDateString('en-US', { weekday: 'short' });
  var finaldate = dayshort + '. ' + month + '/' + day;
  return finaldate;
}

function errZipMsg(loc) {
  $('.zip-error-msg').append('Thank you for your interest in purchasing a Fujifilm product. Unfortunately, we do not ship to ' + loc + ' at this time.');
  $('.zip-error-msg').show();
  $('.fedex-delivery-dates').hide();
}

var calculateShipDates = function(zip) {
  if(zip.length < 1) { zip = '90210';}
  var zipFindVar = zip.substring(0,3);
  if(zipFindVar == '006' || zipFindVar == '007' || zipFindVar == '009') {
    errZipMsg('Puerto Rico');
  }
  else {
    return $.ajax({
      url: '/server_side_carts/shipping_estimate/guest',
      type: 'POST',
      beforeSend: function(xhr) {
        xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
      },
      data: { zip_code: zip, country_code: "US"},
      dataType: "json",
      success: function(data){
        console.log(data);
      },
      error: function(data) {
        console.log(data);
      }
    })
      .done(function(data) {
        var shipGroundMinEst = data.FEDEX_GROUND.delivery_estimate.min;
        var shipGroundMaxEst = data.FEDEX_GROUND.delivery_estimate.max;
        var shipGroundAm = data.FEDEX_GROUND.amount;
        var shipTwoDayMinEst = data.FEDEX_2_DAY.delivery_estimate.min;
        var shipTwoDayMaxEst = data.FEDEX_2_DAY.delivery_estimate.max;
        var shipTwoDayAm = data.FEDEX_2_DAY.amount;
        var shipMinGround = formatShipDate(shipGroundMinEst);
        var shipMaxGround = formatShipDate(shipGroundMaxEst);
        var shipMinTwoDay = formatShipDate(shipTwoDayMinEst);
        var shipMaxTwoDay = formatShipDate(shipTwoDayMaxEst);
        var shipMinGroundShort = dayjs(shipGroundMinEst).format("ddd, MM/DD");
        var shipMaxGroundShort = dayjs(shipGroundMaxEst).format("ddd, MM/DD");
        var shipMinTwoDayShort = dayjs(shipTwoDayMinEst).format("ddd, MM/DD");
        var shipMaxTwoDayShort = dayjs(shipTwoDayMaxEst).format("ddd, MM/DD");


        $("#order_est_delivery strong").html(shipMaxGround);
        $('#ship-ground-mark').html(shipMaxGround);
        $('#ship-two-day-mark').html(shipMaxTwoDay);
        $('#ship-ground-mark-checkout, .ship-copy-ground').html('Est. Arrival: ' + shipMinGroundShort + ' - ' + shipMaxGroundShort);
        $('#ship-two-day-mark-checkout, .ship-copy-two-day').html('Est. Arrival: ' + shipMinTwoDayShort + ' - ' + shipMaxTwoDayShort);
        $('.fedex-delivery-dates').css('opacity', '1');
      })
      .fail(function(data) {
        $('.fedex-delivery-dates').css('opacity', '0');
        $('.fedex-delivery-dates').slideUp();
      });
  }
}

var convertMoney = function(val) {
  if(val != null) {
    var strValc = '' + val;
    var newVal = parseFloat(strValc.replace(/\$|,/g, ''));
    return newVal;
  }
}

var addToCartAct = function(p, acc, tagLoc) {

    fbq('track', 'AddToCart', { // Meta Pixel tracking
      content_name: decodeURIComponent(p.name),
      content_category: decodeURIComponent(p.category),
      content_ids: [decodeURIComponent(p.id)],
      content_type: 'product',
      value: p.price,
      currency: 'USD'
    });

    var productAdd = [{
      id: decodeURIComponent(p.id), // Product_id / sku
      name: decodeURIComponent(p.name), // Product name
      category: decodeURIComponent(p.category), // Category of product; Cameras / Lenses / Accessories
      variant: '', // Color variant of product; skip if not used
      brand: decodeURIComponent(p.brand),
      quantity: decodeURIComponent(p.quantity), // The quantity of added to cart product
      price: convertMoney(p.price) // The price of one item
    }];
    if(acc.id != null && acc.price != null) {
      var productAddAcc = {
        id: decodeURIComponent(acc.id),
        name: decodeURIComponent(acc.name),
        category: '',
        brand: '',
        quantity: acc.quantity,
        price: convertMoney(acc.price)
      }
      productAdd.push(productAddAcc);
    }
    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: 'eec.add',
      ecommerce: {
        add: {
          products: productAdd
        }
      }
    });
}

var purchaseAct = function(order, p) {
  window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: 'eec.purchase',
    ecommerce: {
      currencyCode: 'USD', // Currency of transaction
      purchase: {
        actionField: {
          id: decodeURIComponent(order.id), // The transaction ID
          affiliation: decodeURIComponent('Online Store'), // The store or affiliation from which this transaction occurred; is it possible to have different ones?
          revenue: convertMoney(order.revenue), // Total transaction value or revenue (Total transaction value - tax - shipping)
          tax: convertMoney(order.tax), // Tax paid
          shipping: convertMoney(order.shipping), // Cost of shipping
          coupon: decodeURIComponent(order.coupon) // Promo code applied, related to whole transaction
        },
        products: p
      }
    }
  });
}

var prodViewTag = function(detId, detName, detCategory, detPrice) {
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'eec.detail',
    ecommerce: {
      detail: {
        products: [{
          id: decodeURIComponent(detId),
          name: decodeURIComponent(detName),
          category: '',
          variant: '',
          brand: decodeURIComponent('Fujifilm'),
          price: convertMoney(detPrice)
        }]
      }
    }
  });
}

var removeCartTag = function(id, name, cat, variant, brand, qty, price) {
  window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: 'eec.remove',
    ecommerce: {
      remove: {
        products: [{
          id: decodeURIComponent(id),
          name: decodeURIComponent(name),
          category: decodeURIComponent(cat),
          variant: '',
          brand: decodeURIComponent('Fujifilm'),
          quantity: qty,
          price: price,
        }]
      }
    }
  });
}


var searchAddCart = function(i) {
  if (window.location.href.indexOf("fujifilm-x") > -1) {
    var locStat = 'Search results';
    var scSku = i.sku;
    var scName = i.name;
    var scPrice = i.price;
    var scBrand = '';
    var scCat = '';

    var searchParams = new URLSearchParams(window.location.search);
    if(searchParams.has('brands')) {
      scBrand = searchParams.get('brands');
    }
    if(searchParams.has('categories')) {
      var scCat = 'Category ' + searchParams.get('categories');
    }
    if(scCat.length > 0) locStat = scCat;
    var scDetails = {
      id: decodeURIComponent(scSku),
      name: decodeURIComponent(scName),
      category: decodeURIComponent(scCat),
      brand: decodeURIComponent(scBrand),
      price: convertMoney(scPrice),
      quantity: 1
    }
    var iAcc = {
      id: '',
      name: '',
      category: '',
      brand: 'Fujifilm',
      quantity: 0,
      price: ''
    };
    addToCartAct(scDetails, iAcc, locStat);
  }
}

var gtmCartTrack = function(t) {
  // Google Tag Fujifilm
  var qtySku = $(t).data('sku');
  var qtyName = $(t).data('prodname');
  var qtyPrice = $(t).data('price');
  var qtyPrev = $(t).data('qtyval');
  var qtyNumNext = $(t).find('option:selected').val();
  var qtyDiff = qtyPrev - qtyNumNext;
  var qtyPlus =  qtyNumNext - qtyPrev;
  var qtyDiffE = Math.abs(qtyDiff);
  if(qtyDiff > 0) {
    removeCartTag(qtySku, qtyName, '', '', '', qtyDiffE, convertMoney(qtyPrice));
  }
  else if(qtyPlus > 0) {
    var qsDetails = {
      id: qtySku,
      name: qtyName,
      price: qtyPrice,
      quantity: qtyPlus
    }
    var iAcc = { };
    addToCartAct(qsDetails, iAcc, 'Cart');
  }
}

var gtmCartRemove = function(t) {
  // Google Tag Fujifilm
  var qtySku = $(t).data('sku');
  var qtyName = $(t).data('prodname');
  var qtyPrice = $(t).data('price');
  var qtyPrev = $(t).closest('select').data('qtyval');
  var qtyDiff = $(t).data('current-quantity');
  removeCartTag(qtySku, qtyName, '', '', '', qtyDiff, convertMoney(qtyPrice));
}

var gtmRecTag = function(arr) {
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'eec.impressionView',
    ecommerce: {
      impressions: arr
    }
  });
}

var bestDataRec = function(loc) {
  var displayRecArray = []
  $('.slick-active .rec-img-link').each(function(i, obj) {
    var impressTrigger = $(obj).data('impression-done');
    if(impressTrigger != 'true') {
      var dataSku = $(obj).data('sku');
      var dataName = $(obj).data('name');
      var dataCategory = $(obj).data('category');
      var dataBrand = $(obj).data('brand');
      var dataList = loc;
      var incI = $(obj).data('ipos');
      var displayRecItem = {
        id: decodeURIComponent(dataSku),
        name: decodeURIComponent(dataName),
        category: decodeURIComponent(dataCategory),
        brand: decodeURIComponent(dataBrand),
        list: decodeURIComponent(dataList),
        position: incI
      }
      displayRecArray.push(displayRecItem);
      $(obj).data('impression-done', 'true');
    }
  });
  gtmRecTag(displayRecArray);
}

var gtmRecSlider = function(loc) {
  var displayRecArray = [];
  $('.rec-img-link').each(function(i, obj) {
    var impressTrigger = $(this).data('impression-done');
    if(impressTrigger != 'true') {
      if ($(this).parents('.slick-active').length) {
        var dataSku = $(this).data('sku');
        var dataName = $(this).data('name');
        var dataCategory = $(this).data('category');
        var dataBrand = $(this).data('brand');
        var dataList = loc;
        var incI = $(this).data('ipos');
        var displayRecItem = {
          id: decodeURIComponent(dataSku),
          name: decodeURIComponent(dataName),
          category: decodeURIComponent(dataCategory),
          brand: decodeURIComponent(dataBrand),
          list: decodeURIComponent(dataList),
          position: incI
        }
        displayRecArray.push(displayRecItem);
        $(this).data('impression-done', 'true');
      }
    }
  })
  if(displayRecArray.length > 0) {
    gtmRecTag(displayRecArray);
  }
}

var gtmAccOptions = function(loc) {
  var displayAccArray = [];
  $('.pdp-accessories-options input[type="radio"]').each(function (i, obj) {
    var impressTrigger = $(this).data('sprodname');
    if (impressTrigger != null && impressTrigger != '') {
      var dataSku = $(this).data('sid');
      var dataName = $(this).data('sprodname');
      var dataIpos = $(this).data('ipos');
      var displayAccItem = {
        id: decodeURIComponent(dataSku),
        name: decodeURIComponent(dataName),
        category: '',
        brand: '',
        list: loc,
        position: dataIpos
      }
      displayAccArray.push(displayAccItem);
    }
  })
  if (displayAccArray.length > 0) {
    gtmRecTag(displayAccArray);
  }
}

var gtmImpressClick = function(arr) {
  window.dataLayer.push({ecommerce: null});
  window.dataLayer.push({
    event: 'eec.impressionClick',
    ecommerce: {
      click: {
        actionField: {
          list: decodeURIComponent(arr.loc)
        },
        products: [{
          id: decodeURIComponent(arr.id),
          name: decodeURIComponent(arr.name),
          category: decodeURIComponent(arr.cat),
          brand: '',
          list: '',
          position: arr.pos
        }]
      }
    }
  });
}

$('body.ecommerce-home-page .recommended-img a, body.ecommerce-home-page .recommended-desc a').on('click', function() {
  var impRecItem = {
    loc: 'Best Sellers - Homepage',
    id: $(this).data('prod-sku'),
    name: $(this).data('prod-name'),
    cat: '',
    pos: $(this).data('ipos')
  }
  gtmImpressClick(impRecItem);
});

$('body.ecommerce-pdp-page .recommended-img a, body.ecommerce-pdp-page .recommended-desc a').on('click', function() {
  var impRecItem = {
    loc: 'Best Sellers - Product detail',
    id: $(this).data('prod-sku'),
    name: $(this).data('prod-name'),
    cat: '',
    pos: $(this).data('ipos')
  }
  gtmImpressClick(impRecItem);
});

$('body.ecommerce-order-confirm-page .recommended-img a, body.ecommerce-order-confirm-page .recommended-desc a').on('click', function() {
  var impRecItem = {
    loc: 'Best Sellers - Order confirmation',
    id: $(this).data('prod-sku'),
    name: $(this).data('prod-name'),
    cat: '',
    pos: $(this).data('ipos')
  }
  gtmImpressClick(impRecItem);
});


$('ul.nav a.nav-press').on('click', function() {
  var imgPress = $(this).children('img.img-details');
  var impRecItem = {
    loc: 'Navigation',
    id: imgPress.data('psku'),
    name: imgPress.data('pname'),
    cat: imgPress.data('pcat'),
    pos: imgPress.data('pipos')
  }
  gtmImpressClick(impRecItem);
});


$(document.body).on('click', '.search-item-img, .search-item-name-and-sku a' ,function() {
  var impRecItem = {
    loc: 'Search results',
    id: $(this).data('prod-sku'),
    name: $(this).data('prod-name'),
    cat: '',
    pos: $(this).data('ipos')
  }
  gtmImpressClick(impRecItem);
});


$(document).ready(function() {
  if (!localStorage.bannerClosed) {
    $('.cookieinfo-banner').css('display', 'inherit');
  } else {
    $('.cookieinfo-banner').css('display', 'none');
  }
  $('.cookieinfo-accept').on('click', function() {
    $('.cookieinfo-banner').css('display', 'none');
    $('#cookie_policy_accepted').val(1);
    localStorage.bannerClosed = 'true'
  });
});
$.ajaxSetup({
  beforeSend: function (xhr) {
    xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
  }
});

var renderAddedToCartModal = function(mapping) {
  var template = _.template($('#added-to-card-modal-template').html());
  return template(mapping);
}

var addCartItem = function(sku, qty) {
  return RegistriaShoppingCart.addLine(sku, qty, null, {
    success: function(data) {
      window.shoppingCart = data;
    }
  });
}

var calculateShipping = function() {
  return RegistriaShoppingCart.calculateShipping({
    success: function(data) {
      window.shoppingCart.cart_shipping_total = toMoney(data["FEDEX_GROUND"]);
    },
    error: function() {
      window.shoppingCart.cart_shipping_total = $.polyglot.t('messages.shipping_not_available');
    }
  });
}

var calculateTax = function() {
  return RegistriaShoppingCart.calculateTax({
    success: function(data) {
      if (isNaN(toNumber(data.cart_tax))) {
        window.shoppingCart.cart_tax = $.polyglot.t('messages.tax_not_available');
        window.shoppingCart.cart_total = window.shoppingCart.cart_sub_total;
      } else {
        window.shoppingCart.cart_tax = data.cart_tax;
        window.shoppingCart.cart_total = data.cart_total;
      }
    },
    error: function() {
      window.shoppingCart.cart_tax = $.polyglot.t('messages.tax_not_available');
      window.shoppingCart.cart_total = window.shoppingCart.cart_sub_total;
    }
  });
}

var showAddedToCartModal = function(productInfo) {
  var cart = window.shoppingCart;
  var sci = _.find(cart.shopping_cart_items, { 'sku': productInfo.sku });
  updateCartItemCount();

  var savings = "";
  var basePrice = "";
  var savePercent = "";

  if (productInfo.basePrice > productInfo.price) {
    savePercent = (1 - (productInfo.price / productInfo.basePrice)) * 100;
    var savePercentDisplay = savePercent.toFixed(1);
    savings = $.polyglot.t('label.save_discount') + ' ' + toMoney(productInfo.basePrice - productInfo.price) + ' (' + Math.round(savePercentDisplay) + '%)';
    basePrice = toMoney(productInfo.basePrice);
  }

  var shipping_total_mtext = cart.cart_shipping_total;
  if(shipping_total_mtext == '$NaN') {
    shipping_total_mtext = "Shipping available at payment";
  }

  var header = productInfo.itemsAdded;
  header += " ";
  header += productInfo.itemsAdded > 1 ? $.polyglot.t('header.items') : $.polyglot.t('header.item');
  header += " ";
  header += $.polyglot.t('header.added_to_cart');

  var modal = $(renderAddedToCartModal({
    sku: productInfo.sku,
    name: productInfo.name,
    model: sci.external_name,
    price: toMoney(productInfo.price),
    basePrice: basePrice,
    savings: savings,
    shipping: shipping_total_mtext,
    tax: cart.cart_tax,
    subtotal: cart.cart_sub_total,
    cartTotal: cart.cart_total,
    itemCount: pluralize(cart.cart_total_items, "Item", "Items"),
    header: header,
    imageUrl: productInfo.image
  }));

  modal
    .modal('show')
    .on('hidden.bs.modal', function(e) {
      modal.remove();
      $('.pdp-add-to-cart-btn').removeClass('disable-pointer');
      $('.pdp-add-to-cart-btn').prop('disabled', false);
      sessionStorage.clickcount = 0;
    })
}

function updateCartItemCount() {
  $(".cart_count").html(window.shoppingCart.cart_total_items);
}

function pluralize(count, singular, plural) {
  if (count === 0 || count > 1) {
    return count + " " + plural
  } else {
    return count + " " + singular
  }
}

/*! lightslider - v1.1.3 - 2015-07-18
* https://github.com/sachinchoolur/lightslider
* Copyright (c) 2015 Sachin N; Licensed MIT */
!function(a,b){"use strict";var c={item:3,autoWidth:!1,slideMove:1,slideMargin:10,addClass:"",mode:"slide",useCSS:!0,cssEasing:"ease",easing:"linear",speed:400,auto:!1,loop:!1,slideEndAnimation:!0,pause:2e3,keyPress:!1,controls:!0,prevHtml:"",nextHtml:"",rtl:!1,adaptiveHeight:!1,vertical:!1,verticalHeight:500,vThumbWidth:100,thumbItem:10,pager:!0,gallery:!1,galleryMargin:5,thumbMargin:5,currentPagerPosition:"middle",enableTouch:!0,enableDrag:!0,freeMove:!0,swipeThreshold:40,responsive:[],onBeforeStart:function(a){},onSliderLoad:function(a){},onBeforeSlide:function(a,b){},onAfterSlide:function(a,b){},onBeforeNextSlide:function(a,b){},onBeforePrevSlide:function(a,b){}};a.fn.lightSlider=function(b){if(0===this.length)return this;if(this.length>1)return this.each(function(){a(this).lightSlider(b)}),this;var d={},e=a.extend(!0,{},c,b),f={},g=this;d.$el=this,"fade"===e.mode&&(e.vertical=!1);var h=g.children(),i=a(window).width(),j=null,k=null,l=0,m=0,n=!1,o=0,p="",q=0,r=e.vertical===!0?"height":"width",s=e.vertical===!0?"margin-bottom":"margin-right",t=0,u=0,v=0,w=0,x=null,y="ontouchstart"in document.documentElement,z={};return z.chbreakpoint=function(){if(i=a(window).width(),e.responsive.length){var b;if(e.autoWidth===!1&&(b=e.item),i<e.responsive[0].breakpoint)for(var c=0;c<e.responsive.length;c++)i<e.responsive[c].breakpoint&&(j=e.responsive[c].breakpoint,k=e.responsive[c]);if("undefined"!=typeof k&&null!==k)for(var d in k.settings)k.settings.hasOwnProperty(d)&&(("undefined"==typeof f[d]||null===f[d])&&(f[d]=e[d]),e[d]=k.settings[d]);if(!a.isEmptyObject(f)&&i>e.responsive[0].breakpoint)for(var g in f)f.hasOwnProperty(g)&&(e[g]=f[g]);e.autoWidth===!1&&t>0&&v>0&&b!==e.item&&(q=Math.round(t/((v+e.slideMargin)*e.slideMove)))}},z.calSW=function(){e.autoWidth===!1&&(v=(o-(e.item*e.slideMargin-e.slideMargin))/e.item)},z.calWidth=function(a){var b=a===!0?p.find(".lslide").length:h.length;if(e.autoWidth===!1)m=b*(v+e.slideMargin);else{m=0;for(var c=0;b>c;c++)m+=parseInt(h.eq(c).width())+e.slideMargin}return m},d={doCss:function(){var a=function(){for(var a=["transition","MozTransition","WebkitTransition","OTransition","msTransition","KhtmlTransition"],b=document.documentElement,c=0;c<a.length;c++)if(a[c]in b.style)return!0};return e.useCSS&&a()?!0:!1},keyPress:function(){e.keyPress&&a(document).on("keyup.lightslider",function(b){a(":focus").is("input, textarea")||(b.preventDefault?b.preventDefault():b.returnValue=!1,37===b.keyCode?(g.goToPrevSlide(),clearInterval(x)):39===b.keyCode&&(g.goToNextSlide(),clearInterval(x)))})},controls:function(){e.controls&&(g.after('<div class="lSAction"><a class="lSPrev">'+e.prevHtml+'</a><a class="lSNext">'+e.nextHtml+"</a></div>"),e.autoWidth?z.calWidth(!1)<o&&p.find(".lSAction").hide():l<=e.item&&p.find(".lSAction").hide(),p.find(".lSAction a").on("click",function(b){return b.preventDefault?b.preventDefault():b.returnValue=!1,"lSPrev"===a(this).attr("class")?g.goToPrevSlide():g.goToNextSlide(),clearInterval(x),!1}))},initialStyle:function(){var a=this;"fade"===e.mode&&(e.autoWidth=!1,e.slideEndAnimation=!1),e.auto&&(e.slideEndAnimation=!1),e.autoWidth&&(e.slideMove=1,e.item=1),e.loop&&(e.slideMove=1,e.freeMove=!1),e.onBeforeStart.call(this,g),z.chbreakpoint(),g.addClass("lightSlider").wrap('<div class="lSSlideOuter '+e.addClass+'"><div class="lSSlideWrapper"></div></div>'),p=g.parent(".lSSlideWrapper"),e.rtl===!0&&p.parent().addClass("lSrtl"),e.vertical?(p.parent().addClass("vertical"),o=e.verticalHeight,p.css("height",o+"px")):o=g.outerWidth(),h.addClass("lslide"),e.loop===!0&&"slide"===e.mode&&(z.calSW(),z.clone=function(){if(z.calWidth(!0)>o){for(var b=0,c=0,d=0;d<h.length&&(b+=parseInt(g.find(".lslide").eq(d).width())+e.slideMargin,c++,!(b>=o+e.slideMargin));d++);var f=e.autoWidth===!0?c:e.item;if(f<g.find(".clone.left").length)for(var i=0;i<g.find(".clone.left").length-f;i++)h.eq(i).remove();if(f<g.find(".clone.right").length)for(var j=h.length-1;j>h.length-1-g.find(".clone.right").length;j--)q--,h.eq(j).remove();for(var k=g.find(".clone.right").length;f>k;k++)g.find(".lslide").eq(k).clone().removeClass("lslide").addClass("clone right").appendTo(g),q++;for(var l=g.find(".lslide").length-g.find(".clone.left").length;l>g.find(".lslide").length-f;l--)g.find(".lslide").eq(l-1).clone().removeClass("lslide").addClass("clone left").prependTo(g);h=g.children()}else h.hasClass("clone")&&(g.find(".clone").remove(),a.move(g,0))},z.clone()),z.sSW=function(){l=h.length,e.rtl===!0&&e.vertical===!1&&(s="margin-left"),e.autoWidth===!1&&h.css(r,v+"px"),h.css(s,e.slideMargin+"px"),m=z.calWidth(!1),g.css(r,m+"px"),e.loop===!0&&"slide"===e.mode&&n===!1&&(q=g.find(".clone.left").length)},z.calL=function(){h=g.children(),l=h.length},this.doCss()&&p.addClass("usingCss"),z.calL(),"slide"===e.mode?(z.calSW(),z.sSW(),e.loop===!0&&(t=a.slideValue(),this.move(g,t)),e.vertical===!1&&this.setHeight(g,!1)):(this.setHeight(g,!0),g.addClass("lSFade"),this.doCss()||(h.fadeOut(0),h.eq(q).fadeIn(0))),e.loop===!0&&"slide"===e.mode?h.eq(q).addClass("active"):h.first().addClass("active")},pager:function(){var a=this;if(z.createPager=function(){w=(o-(e.thumbItem*e.thumbMargin-e.thumbMargin))/e.thumbItem;var b=p.find(".lslide"),c=p.find(".lslide").length,d=0,f="",h=0;for(d=0;c>d;d++){"slide"===e.mode&&(e.autoWidth?h+=(parseInt(b.eq(d).width())+e.slideMargin)*e.slideMove:h=d*(v+e.slideMargin)*e.slideMove);var i=b.eq(d*e.slideMove).attr("data-thumb");if(f+=e.gallery===!0?'<li style="width:100%;'+r+":"+w+"px;"+s+":"+e.thumbMargin+'px"><a href="#"><img src="'+i+'" /></a></li>':'<li><a href="#">'+(d+1)+"</a></li>","slide"===e.mode&&h>=m-o-e.slideMargin){d+=1;var j=2;e.autoWidth&&(f+='<li><a href="#">'+(d+1)+"</a></li>",j=1),j>d?(f=null,p.parent().addClass("noPager")):p.parent().removeClass("noPager");break}}var k=p.parent();k.find(".lSPager").html(f),e.gallery===!0&&(e.vertical===!0&&k.find(".lSPager").css("width",e.vThumbWidth+"px"),u=d*(e.thumbMargin+w)+.5,k.find(".lSPager").css({property:u+"px","transition-duration":e.speed+"ms"}),e.vertical===!0&&p.parent().css("padding-right",e.vThumbWidth+e.galleryMargin+"px"),k.find(".lSPager").css(r,u+"px"));var l=k.find(".lSPager").find("li");l.first().addClass("active"),l.on("click",function(){return e.loop===!0&&"slide"===e.mode?q+=l.index(this)-k.find(".lSPager").find("li.active").index():q=l.index(this),g.mode(!1),e.gallery===!0&&a.slideThumb(),clearInterval(x),!1})},e.pager){var b="lSpg";e.gallery&&(b="lSGallery"),p.after('<ul class="lSPager '+b+'"></ul>');var c=e.vertical?"margin-left":"margin-top";p.parent().find(".lSPager").css(c,e.galleryMargin+"px"),z.createPager()}setTimeout(function(){z.init()},0)},setHeight:function(a,b){var c=null,d=this;c=e.loop?a.children(".lslide ").first():a.children().first();var f=function(){var d=c.outerHeight(),e=0,f=d;b&&(d=0,e=100*f/o),a.css({height:d+"px","padding-bottom":e+"%"})};f(),c.find("img").length?c.find("img")[0].complete?(f(),x||d.auto()):c.find("img").load(function(){setTimeout(function(){f(),x||d.auto()},100)}):x||d.auto()},active:function(a,b){this.doCss()&&"fade"===e.mode&&p.addClass("on");var c=0;if(q*e.slideMove<l){a.removeClass("active"),this.doCss()||"fade"!==e.mode||b!==!1||a.fadeOut(e.speed),c=b===!0?q:q*e.slideMove;var d,f;b===!0&&(d=a.length,f=d-1,c+1>=d&&(c=f)),e.loop===!0&&"slide"===e.mode&&(c=b===!0?q-g.find(".clone.left").length:q*e.slideMove,b===!0&&(d=a.length,f=d-1,c+1===d?c=f:c+1>d&&(c=0))),this.doCss()||"fade"!==e.mode||b!==!1||a.eq(c).fadeIn(e.speed),a.eq(c).addClass("active")}else a.removeClass("active"),a.eq(a.length-1).addClass("active"),this.doCss()||"fade"!==e.mode||b!==!1||(a.fadeOut(e.speed),a.eq(c).fadeIn(e.speed))},move:function(a,b){e.rtl===!0&&(b=-b),this.doCss()?a.css(e.vertical===!0?{transform:"translate3d(0px, "+-b+"px, 0px)","-webkit-transform":"translate3d(0px, "+-b+"px, 0px)"}:{transform:"translate3d("+-b+"px, 0px, 0px)","-webkit-transform":"translate3d("+-b+"px, 0px, 0px)"}):e.vertical===!0?a.css("position","relative").animate({top:-b+"px"},e.speed,e.easing):a.css("position","relative").animate({left:-b+"px"},e.speed,e.easing);var c=p.parent().find(".lSPager").find("li");this.active(c,!0)},fade:function(){this.active(h,!1);var a=p.parent().find(".lSPager").find("li");this.active(a,!0)},slide:function(){var a=this;z.calSlide=function(){m>o&&(t=a.slideValue(),a.active(h,!1),t>m-o-e.slideMargin?t=m-o-e.slideMargin:0>t&&(t=0),a.move(g,t),e.loop===!0&&"slide"===e.mode&&(q>=l-g.find(".clone.left").length/e.slideMove&&a.resetSlide(g.find(".clone.left").length),0===q&&a.resetSlide(p.find(".lslide").length)))},z.calSlide()},resetSlide:function(a){var b=this;p.find(".lSAction a").addClass("disabled"),setTimeout(function(){q=a,p.css("transition-duration","0ms"),t=b.slideValue(),b.active(h,!1),d.move(g,t),setTimeout(function(){p.css("transition-duration",e.speed+"ms"),p.find(".lSAction a").removeClass("disabled")},50)},e.speed+100)},slideValue:function(){var a=0;if(e.autoWidth===!1)a=q*(v+e.slideMargin)*e.slideMove;else{a=0;for(var b=0;q>b;b++)a+=parseInt(h.eq(b).width())+e.slideMargin}return a},slideThumb:function(){var a;switch(e.currentPagerPosition){case"left":a=0;break;case"middle":a=o/2-w/2;break;case"right":a=o-w}var b=q-g.find(".clone.left").length,c=p.parent().find(".lSPager");"slide"===e.mode&&e.loop===!0&&(b>=c.children().length?b=0:0>b&&(b=c.children().length));var d=b*(w+e.thumbMargin)-a;d+o>u&&(d=u-o-e.thumbMargin),0>d&&(d=0),this.move(c,d)},auto:function(){e.auto&&(x=setInterval(function(){g.goToNextSlide()},e.pause))},touchMove:function(a,b){if(p.css("transition-duration","0ms"),"slide"===e.mode){var c=a-b,d=t-c;if(d>=m-o-e.slideMargin)if(e.freeMove===!1)d=m-o-e.slideMargin;else{var f=m-o-e.slideMargin;d=f+(d-f)/5}else 0>d&&(e.freeMove===!1?d=0:d/=5);this.move(g,d)}},touchEnd:function(a){if(p.css("transition-duration",e.speed+"ms"),clearInterval(x),"slide"===e.mode){var b=!1,c=!0;t-=a,t>m-o-e.slideMargin?(t=m-o-e.slideMargin,e.autoWidth===!1&&(b=!0)):0>t&&(t=0);var d=function(a){var c=0;if(b||a&&(c=1),e.autoWidth)for(var d=0,f=0;f<h.length&&(d+=parseInt(h.eq(f).width())+e.slideMargin,q=f+c,!(d>=t));f++);else{var g=t/((v+e.slideMargin)*e.slideMove);q=parseInt(g)+c,t>=m-o-e.slideMargin&&g%1!==0&&q++}};a>=e.swipeThreshold?(d(!1),c=!1):a<=-e.swipeThreshold&&(d(!0),c=!1),g.mode(c),this.slideThumb()}else a>=e.swipeThreshold?g.goToPrevSlide():a<=-e.swipeThreshold&&g.goToNextSlide()},enableDrag:function(){var b=this;if(!y){var c=0,d=0,f=!1;p.find(".lightSlider").addClass("lsGrab"),p.on("mousedown",function(b){return o>m&&0!==m?!1:void("lSPrev"!==a(b.target).attr("class")&&"lSNext"!==a(b.target).attr("class")&&(c=e.vertical===!0?b.pageY:b.pageX,f=!0,b.preventDefault?b.preventDefault():b.returnValue=!1,p.scrollLeft+=1,p.scrollLeft-=1,p.find(".lightSlider").removeClass("lsGrab").addClass("lsGrabbing"),clearInterval(x)))}),a(window).on("mousemove",function(a){f&&(d=e.vertical===!0?a.pageY:a.pageX,b.touchMove(d,c))}),a(window).on("mouseup",function(g){if(f){p.find(".lightSlider").removeClass("lsGrabbing").addClass("lsGrab"),f=!1,d=e.vertical===!0?g.pageY:g.pageX;var h=d-c;Math.abs(h)>=e.swipeThreshold&&a(window).on("click.ls",function(b){b.preventDefault?b.preventDefault():b.returnValue=!1,b.stopImmediatePropagation(),b.stopPropagation(),a(window).off("click.ls")}),b.touchEnd(h)}})}},enableTouch:function(){var a=this;if(y){var b={},c={};p.on("touchstart",function(a){c=a.originalEvent.targetTouches[0],b.pageX=a.originalEvent.targetTouches[0].pageX,b.pageY=a.originalEvent.targetTouches[0].pageY,clearInterval(x)}),p.on("touchmove",function(d){if(o>m&&0!==m)return!1;var f=d.originalEvent;c=f.targetTouches[0];var g=Math.abs(c.pageX-b.pageX),h=Math.abs(c.pageY-b.pageY);e.vertical===!0?(3*h>g&&d.preventDefault(),a.touchMove(c.pageY,b.pageY)):(3*g>h&&d.preventDefault(),a.touchMove(c.pageX,b.pageX))}),p.on("touchend",function(){if(o>m&&0!==m)return!1;var d;d=e.vertical===!0?c.pageY-b.pageY:c.pageX-b.pageX,a.touchEnd(d)})}},build:function(){var a=this;a.initialStyle(),this.doCss()&&(e.enableTouch===!0&&a.enableTouch(),e.enableDrag===!0&&a.enableDrag()),a.pager(),a.controls(),a.keyPress()}},d.build(),z.init=function(){z.chbreakpoint(),e.vertical===!0?(o=e.item>1?e.verticalHeight:h.outerHeight(),p.css("height",o+"px")):o=p.outerWidth(),e.loop===!0&&"slide"===e.mode&&z.clone(),z.calL(),"slide"===e.mode&&g.removeClass("lSSlide"),"slide"===e.mode&&(z.calSW(),z.sSW()),setTimeout(function(){"slide"===e.mode&&g.addClass("lSSlide")},1e3),e.pager&&z.createPager(),e.adaptiveHeight===!0&&e.vertical===!1&&g.css("height",h.eq(q).outerHeight(!0)),e.adaptiveHeight===!1&&("slide"===e.mode?e.vertical===!1?d.setHeight(g,!1):d.auto():d.setHeight(g,!0)),e.gallery===!0&&d.slideThumb(),"slide"===e.mode&&d.slide(),e.autoWidth===!1?h.length<=e.item?p.find(".lSAction").hide():p.find(".lSAction").show():z.calWidth(!1)<o&&0!==m?p.find(".lSAction").hide():p.find(".lSAction").show()},g.goToPrevSlide=function(){if(q>0)e.onBeforePrevSlide.call(this,g,q),q--,g.mode(!1),e.gallery===!0&&d.slideThumb();else if(e.loop===!0){if(e.onBeforePrevSlide.call(this,g,q),"fade"===e.mode){var a=l-1;q=parseInt(a/e.slideMove)}g.mode(!1),e.gallery===!0&&d.slideThumb()}else e.slideEndAnimation===!0&&(g.addClass("leftEnd"),setTimeout(function(){g.removeClass("leftEnd")},400))},g.goToNextSlide=function(){var a=!0;if("slide"===e.mode){var b=d.slideValue();a=b<m-o-e.slideMargin}q*e.slideMove<l-e.slideMove&&a?(e.onBeforeNextSlide.call(this,g,q),q++,g.mode(!1),e.gallery===!0&&d.slideThumb()):e.loop===!0?(e.onBeforeNextSlide.call(this,g,q),q=0,g.mode(!1),e.gallery===!0&&d.slideThumb()):e.slideEndAnimation===!0&&(g.addClass("rightEnd"),setTimeout(function(){g.removeClass("rightEnd")},400))},g.mode=function(a){e.adaptiveHeight===!0&&e.vertical===!1&&g.css("height",h.eq(q).outerHeight(!0)),n===!1&&("slide"===e.mode?d.doCss()&&(g.addClass("lSSlide"),""!==e.speed&&p.css("transition-duration",e.speed+"ms"),""!==e.cssEasing&&p.css("transition-timing-function",e.cssEasing)):d.doCss()&&(""!==e.speed&&g.css("transition-duration",e.speed+"ms"),""!==e.cssEasing&&g.css("transition-timing-function",e.cssEasing))),a||e.onBeforeSlide.call(this,g,q),"slide"===e.mode?d.slide():d.fade(),setTimeout(function(){a||e.onAfterSlide.call(this,g,q)},e.speed),n=!0},g.play=function(){clearInterval(x),g.goToNextSlide(),x=setInterval(function(){g.goToNextSlide()},e.pause)},g.pause=function(){clearInterval(x)},g.refresh=function(){z.init()},g.getCurrentSlideCount=function(){var a=q;if(e.loop){var b=p.find(".lslide").length,c=g.find(".clone.left").length;a=c-1>=q?b+(q-c):q>=b+c?q-b-c:q-c}return a+1},g.getTotalSlideCount=function(){return p.find(".lslide").length},g.goToSlide=function(a){q=e.loop?a+g.find(".clone.left").length-1:a,g.mode(!1),e.gallery===!0&&d.slideThumb()},setTimeout(function(){e.onSliderLoad.call(this,g)},10),a(window).on("resize orientationchange",function(a){setTimeout(function(){a.preventDefault?a.preventDefault():a.returnValue=!1,z.init()},200)}),this}}(jQuery);
/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,a,r,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(r=c,a=u):(r=d.outerWidth(),a=d.outerHeight()),m=(e.width-c)/r,l=(e.height-u)/a,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,r),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),a=document.createElement("img"),r=o(a),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,a.onload=null,r.remove()}.bind(this,i.style.position,i.style.overflow)),a.onload=function(){function t(t){f.init(),f.move(t),r.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(a):!1)}function n(){r.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(a):!1)}var f=o.zoom(i,u,a,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(a)},a.setAttribute("role","presentation"),a.alt="",a.src=e.url})},o.fn.zoom.defaults=t})(window.jQuery);
$(function() {
  $("#email").off("blur");
});

$("#backorder_signup").on("submit", function(e) {
  e.preventDefault();

  payload = serializeObject($(this));

  $.ajax({
    url: $(this).prop("action"),
    method: "POST",
    dataType: "json",
    data: payload
  })
  .done(function(data) {
    // Search Rsults - Uncomment if Notify me / Backorder button goes to Shipping Info modal -> Email signup (not straight to signup)
    // var catchExBo = sessionStorage.getItem('backorder_signup');
    // if(catchExBo != null) {
    //   catchExBo += ', ' + payload.product_id;
    //   sessionStorage.setItem('backorder_signup', catchExBo);
    // }
    // else {
    //   var newExBo = payload.product_id;
    //   sessionStorage.setItem('backorder_signup', newExBo);
    // }

    $("#backorder_signup").hide();
    $("#backorder_signup_success").show();
  })
  .fail(function(data) {
    $("#invalid-email").show();
  })
})

